import { Component, OnInit } from '@angular/core';
import { UserService } from '../shared/user.service';
import { LoaderService } from '../../shared/services/loader.service';
import { NavigationService } from '../../shared/services/navigation.service';
import { Region } from '../shared/region.model';
import { BluechatService } from '../../bluechat/bluechat.service';
import { BluechatAgentCreation } from '../../bluechat/models/BluechatAgentCreation';
import { UserInfoWithNames } from '../user-table/user-table.component';
import { Subject } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { FEATURES, FeatureService } from '../../shared/services/feature.service';
import {UserSearchCriteria} from '../../shared/user-search-criteria';
import { UserInfo } from '../shared/user-info.model';

@Component({
  selector: 'app-chep-manager-list',
  templateUrl: './chep-manager-list.component.html',
  styleUrls: ['./chep-manager-list.component.scss']
})
export class ChepManagerListComponent implements OnInit {

  regions: Region[] = [];

  bluechatMultiUserActivationSubject: Subject<void> = new Subject();
  bluechatEnabled = false;
  filters = new UserSearchCriteria();

  loadPage = (page: number, pageSize: number) => this.userService.searchChepManagers(this.regions, page, pageSize, this.filters);

  activateBluechat = (userDetails: UserInfoWithNames) =>
    this.bluechatService.enableBluechatOnChepManager(userDetails.user.id, this.createBluechatAgentCreationRequest(userDetails));

  constructor(
    private route: ActivatedRoute,
    private userService: UserService,
    private navigation: NavigationService,
    private loader: LoaderService,
    private bluechatService: BluechatService,
    private featureService: FeatureService,
  ) {
  }

  ngOnInit() {
    this.route.data.subscribe(data => {
      this.regions = data.regions;
    });

    this.featureService.getFeatureStatusObservable(FEATURES.BLUECHAT).subscribe(bluechatStatus => this.bluechatEnabled = bluechatStatus);
  }

  goToCreateChepManager(): void {
    this.navigation.chepManagers()
      .create()
      .go();
  }

  goToEditChepManager(id: string): void {
    this.navigation.chepManagers()
      .edit(id)
      .go();
  }

  goToCreateDuplicateChepManager(userInfo: UserInfo): void {
    this.navigation.chepManagers()
      .createDuplicate(userInfo.allowedRegions)
      .go();
  }

  triggerBluechatActivationForSelectedUsers() {
    this.bluechatMultiUserActivationSubject.next();
  }

  private createBluechatAgentCreationRequest(userInfo: UserInfoWithNames): BluechatAgentCreation {
    return {
      firstname: userInfo.firstname,
      lastname: userInfo.lastname,
      email: userInfo.user.email,
    };
  }
}
